<template>
  <div class="ele-page">
    <formGroup>叉乘元素</formGroup>
    <div class="tip">
      叉乘条件:
      <span>不同应用、版位的转化出价分别</span>
      <i class="el-icon-close"/>
      <span>不同应用、版位的创意组分别</span>
      <i class="el-icon-close"/>
      <span>广告标题</span>
      <i>=</i>
      <span>广告创意数量</span>
    </div>
    <div class="list-box">
      <div class="list-box-item">
        <div class="title">
          <span>转化出价</span>
          <p @click="handleEditConversion">
            <i class="el-icon-edit-outline"></i>
            编辑
          </p>
        </div>
        <div class="content" v-infinite-scroll="()=>loadItemData('conversion')">
            <div 
              class="content-item" 
              v-for="item in convList"
              :key="item.app_id"
            >
              <div class="item-head" v-if="item.app_id">
                <p class="ellipsis" :title="item.app_name">{{item.app_name}}</p>
                <span>({{item.app_id}})</span>
              </div>
              <div 
                class="item-child" 
                v-for="child in item.children"
                :key="item.app_id+child.param_id"
              >
                <span>{{child.param_name}}：{{addType ===1?child.num*appList.length:child.num}}</span>
              </div>
            </div>
        </div>
      </div>
       <div class="list-box-item">
        <div class="title">
          <span>创意组</span>
          <p @click="handleAdSource">
            <i class="el-icon-folder-opened"></i>
            选择素材
          </p>
        </div>
        <!-- <div class="content">
          <div 
            class="content-item" 
            v-for="item in emit_list"
            :key="item.app_id"
          >
            <div class="item-head">
              <p class="ellipsis" :title="item.app_name">{{item.app_name}}</p>
              <span>({{item.app_id}})</span>
            </div>
            <div 
              class="item-child" 
              v-for="child in item.children"
              :key="item.app_id+child.param_id"
            >
              <span>{{child.param_name}}:{{child.num}}</span>
            </div>
          </div>
        </div> -->

        <virtual-list 
          :data-key="'app_id'"
          :data-component="itemAdSourceComponent"
          :estimate-size="80"
          :data-sources="emit_list" 
          class="scroll-list" />
      </div>

      <div class="list-box-item">
        <div class="title">
          <span>广告标题</span>
          <p @click="handleAdTitle">
            <i class="el-icon-circle-plus-outline"></i>
            添加文案
          </p>
        </div>
        <virtual-list 
          :data-key="'id'"
          :data-component="itemTitleComponent"
          :estimate-size="24"
          :data-sources="titlelListVirtua" 
          class="scroll-list" />
      </div>
    </div>

    <el-tooltip ref="cellTip" v-model="showPopper" placement="top-start" effect="dark">
        <div class="tip-apple-content" slot="content">{{tipContent}}</div>
    </el-tooltip>

  </div>
</template>

<script>
import VirtualList from 'vue-virtual-scroll-list'
import TitleItem from './titleItem.vue'
import AdsourceItem from './adsourceItem.vue'
import formGroup from './formGroup.vue'
import { cloneDeep } from 'lodash'
import { conversionDrawer, adSourceDrawer, adTitleDrawer } from '../modal'
import { InfiniteScroll } from 'element-ui'
import { debounce } from 'lodash'
import API from '@/api/marketManage/miBatchAuto'
const defaultSliceLength=10;
export default {
   inject: ['getOption', 'validFormItem'],
  components: {
    formGroup,
    'virtual-list': VirtualList,
  },
  directives: { InfiniteScroll },
  props: {
    TitleItem,
    AdsourceItem,
    campaignType: Array,
    displayType: Array,//版位
    appList: Array,//产品
    account: String,//账户
    addType: Number
  },
  data() { 
    return {
      conversionFormData: {},
      titleList: [],
      titlelListVirtua: [], //用于滚动标题
      itemTitleComponent: TitleItem,
      ad_group_list:[] ,
      emit_list:[], //创意组回显
      itemAdSourceComponent: AdsourceItem,
      conversionList: [],//转化出价
      hideConversionList: [],
      posList: [],//按版位显示的数据
      posData: {},

      showPopper: false, //浮层提醒
      tipContent:'',
      timeoutId:'', // settimeout
    }
  },
  computed: {
    updateConversion() {
      return [...this.displayType, ...this.appList].map(v=>v.param_id || v.app_id).toString()
    },
    convList() {
      if (this.addType === 1) {
        return [
          {
            children:  this.posList
          }
        ]
      }else {
        return this.conversionList;
      }
    }
  },
  watch: {
    displayType(n) {
      if (this.addType === 1) {
        const data = this.posList.reduce((pre, item)=> {
          pre[item.param_id] = item.num || 0;
          return pre;
        }, {});
        const pData = {}
        this.posList = n.map(v=> {
          pData[v.param_id] = this.posData[v.param_id] || [];
          return {
            ...v,
            num: data[v.param_id] || 0
          }
        })
        this.posData = pData;
      }
    },
    updateConversion(n, o) {
      this.handleCoveData()
      this.handleSourceData()
    },
    titleList:function() {
      this.titlelListVirtua = this.titleList.map((item,index)=>{
        return {
          name: item,
          id: index + 1,
        }
      })
    }
  },
  created() {
  },
  mounted() {
        const fn = (list , cb)=> {
        
          const checkDis = list.reduce((pre, item)=> {
            pre[item.param_id] = true;
            return pre;
          }, {});
          let loop =false;
          [...this.conversionList, ...this.hideConversionList, ...this.emit_list].forEach(v=> {
            v.children.forEach(item=> {
              if (checkDis[item.param_id]) {
                if (item.num>0) {
                 loop = true;
                //  有数据
                  cb(true)
                  return;
                }
              }
            });
            if (loop) {
              return;
            }
          });
          // 没数据
          if (!loop) {
            cb(false)
          }
        }
        this.$bus.$on('hasAddDate', fn);
        this.$once('hook:beforeDestroy', () => {
           this.$bus.$off('hasAddDate', fn)
        });
    },
  methods: {
    handleCoveData() {
      const {list, data } = this.handleonversionData(this.conversionFormData);
      this.conversionList = list.slice(0, defaultSliceLength)
      this.hideConversionList = list.slice(defaultSliceLength, list.length);
      this.conversionFormData = data 
    },
    loadItemData(key) {
      switch (key) {
        case 'conversion':
          this.conversionList.push(...this.hideConversionList.splice(0,3))
          break;
        case 'source':
          this.conversionList.push(...this.hideConversionList.splice(0,3))
          break;
        default:
          break;
      }
    },
    handleEditConversion() {
      if (!this.hasData()) return;
      
      const onSubmit = ({ data, addType })=> {
        this.$emit('update:addType', addType)
        this.setPosData(data, addType);
        const { list } = this.handleonversionData(data, addType);
        if (addType === 1) {
        this.posList = cloneDeep(list[0].children);
        }else {
          this.posList = [];
        }
        this.conversionList = list.slice(0, defaultSliceLength)
        this.hideConversionList = list.slice(defaultSliceLength, list.length);
        this.conversionFormData = data
        vm.close()
      }
      const { vm } = conversionDrawer({
        props: {
          appList: this.appList,
          displayType: [ ...this.displayType ],
          defaultFormObj: {  ...this.conversionFormData },
          account: this.account,
          configOpt: this.getOption(),
          addType: this.addType
        },
        cbs: {
          onSubmit
        }
      })
    },
    // 创意组 素材
    handleAdSource() {
      if (!this.hasData()) return;
      const onSubmit = (data)=> {
        this.ad_group_list = data['ad_group_list']
        this.emit_list = []
        this.$nextTick(()=>{
          this.emit_list = data['emit_list']
        })
        vm.close()
      }

      const { vm } = adSourceDrawer({
        props: {
          appList: this.appList,
          displayType: [ ...this.displayType ],
          edit_ad_group_list: this.ad_group_list,
          config: this.getOption()
        },
        cbs: {
          onSubmit
        }
      })
    },
    handleSourceData() {
      if(!this.appList.length) {
        this.emit_list = []
        this.ad_group_list = {}
        return;
      }
      const { list } = this.handleonversionData(this.conversionFormData);
      let cloneDeepList = cloneDeep(list)
      let cloneDeep_ad_group_list = cloneDeep(this.ad_group_list)
      let all_list = []
      let res_ad_arr = Object.keys(cloneDeep_ad_group_list).length !=0 ? Object.keys(cloneDeep_ad_group_list): []
      res_ad_arr.forEach(item=>{
        this.appList.forEach(itemc=>{
          let app_id = itemc.app_id
          this.displayType.forEach(itemd=>{
           let displayType_id = `${app_id}_${itemd.param_id}`
           all_list.push(displayType_id)
          })

        })
      })

      for(const ele in cloneDeep_ad_group_list) {
        let ele_split = ele.split('_')
        let new_key = `${ele_split[0]}_${ele_split[1]}`
        if(!all_list.includes(new_key)) {
          delete this.ad_group_list[ele]
        }
      }
      
      
      // 版位个数
      let emit_listNum = cloneDeepList.map(item=>{    
          const combinedKeyCondition = /^(\d+)_(\d+)/;
          const combinedKeyResult = this.findArraysByCondition(this.ad_group_list, combinedKeyCondition);
          item.children && item.children.map(item_c => {

              let cur_item = combinedKeyResult[`${item.app_id}_${item_c['value']}`]
              if(cur_item) {
                  item_c['num'] = cur_item['lengthSum'] ? cur_item['lengthSum'] : 0
              }else{

                item_c['num'] = 0
              }
              return item_c
              
          })
          return item
      })
      this.emit_list = emit_listNum

    },
    findArraysByCondition(data, condition) {
        const result = {};
        for (const key in data) {
            const matches = key.match(condition);
            if (matches) {
                const combinedKey = matches.slice(1).join("_");
                const materialList = data[key].material_list;
                const placementtypelength = 1
                const lengthSum = materialList.length * placementtypelength;
                
                const cur_idea_num = data[key].idea_num
                if (!result[combinedKey]) {
                    result[combinedKey] = {
                        arrays: [],
                        lengthSum: 0
                    };
                }

                if (data[key].tf_status == true) {
                    result[combinedKey].arrays.push(data[key]);
                    result[combinedKey].lengthSum += lengthSum;
                } else {
                    result[combinedKey].arrays = []
                    result[combinedKey].lengthSum += cur_idea_num * placementtypelength
                }
                
            }
        }

        return result;
    },
    // 广告标题 添加文案
    handleAdTitle() {
      // if (!this.hasData()) return;
      const onSubmit = (data)=> {
        this.titleList = data
        vm.close()
      }

      const { vm } = adTitleDrawer({
        props: {
          displayType: [ ...this.displayType ],
          eidtTitleList: this.titleList,
          config: this.getOption()
        },
        cbs: {
          onSubmit
        }
      })
    },
    // 处理转出价数据
    handleonversionData(data={}, addType = this.addType) {
      const list = [],keysFormData={};
      this.appList.forEach(v=> {
        const obj = {
          ...v,
          children: []
        }
        this.displayType.forEach(item=> {
          const key = `${v.app_id}_${item.param_id}`;
          const pList = addType === 1? this.posData[item.param_id] : data[key]
          if (pList) {
            keysFormData[key] = pList
          }else {
            keysFormData[key] = []
          }
          obj.children.push({
            ...item,
            num: (pList || []).length
          });
        });
        list.push(obj)
      });
      return { list, data: keysFormData };
    },
    // 判断是否同时选择了产品和版位
    hasData() {
      if (!this.displayType.length || !this.appList.length) {
        this.$message.error('产品或版位不能为空')
        return false;
      }else {
        return true;
      }
    },
    // /获取提交数据
    async validateFn() {
      const { conversion_bid_list, conversion_arr }  = this.getConversionBidList();
      if (conversion_arr.length > 0) {
        const error_list = [];
         const params = {
          account_id: this.account,
          conversion_arr
        }
        const { data: {  conversion_type, deep_conversion_type } } = await API.batchConversionName(params);
        const obj = conversion_type.reduce((pre, item)=> {
          const { tracking_type, app_id, conversion_type, conversion_id } = item;
          const key  = `${app_id}_${tracking_type}_${conversion_type}`;
          pre[key] = conversion_id;
          return pre;
        }, {});
         const deepObj = deep_conversion_type.reduce((pre, item)=> {
          const { tracking_type, app_id, conversion_type, conversion_id } = item;
          const key  = `${app_id}_${tracking_type}_${conversion_type}`;
          pre[key] = conversion_id;
          return pre;
        }, {});
        Object.keys(conversion_bid_list).forEach(v=> {
          const [app_id] = v.split('_');
          conversion_bid_list[v].forEach(item=> {
            const { tracking_type, union_conver_type, conver_id , deep_conver_id, deep_union_conver_type, is_deep} = item;
              if (!conver_id) {
                const key = `${app_id}_${tracking_type}_${union_conver_type}`
                item.conver_id = obj[key] || conver_id;
              };
               if (is_deep ==='1' && !deep_conver_id) {
                const key = `${app_id}_${tracking_type}_${deep_union_conver_type}`
                item.deep_conver_id = deepObj[key] || deep_conver_id;
              };
              
              if (!item.conver_id) {
                error_list.push({ ...item })
              }
              if (is_deep ==='1' &&!item.deep_conver_id) {
                error_list.push({ ...item })
              }
          })
        });
        console.log(conversion_bid_list, 'conversion_bid_list');
        if (error_list.length>0) {
          this.validFormItem('转化出价：存在空的转化名称，请检查')
          return Promise.reject(false)
        }
        
      }
      //  console.log(conversion_bid_list, 'conversion_bid_list1');
      //   this.validFormItem('转化出价：存在空的转化名称，请检查')
      //     return Promise.reject(false)
      return {
        conversion_bid_list: JSON.stringify(conversion_bid_list),//转化出价
        idea_group_list: JSON.stringify(this.ad_group_list),//创意组
        title: JSON.stringify(this.titleList),//创意组
      }
      
    },
    // 获取转出价提交数据
    getConversionBidList() {
      const map = new Map();
      const form = this.conversionFormData;
      const conversion_bid_list = Object.keys(form).reduce((pre, id)=>{
         const [app_id, pos_id] = id.split('_');
         console.log(this.posData, id);
        const list =(this.addType ===1 ?this.posData[pos_id] : form[id]).map(v=> {
          const { convType,follType, name,  price_2, convTarget, deep_price, deepName ,deepConv } = v;
            const [app_id] = id.split('_');
            if (this.addType ===1&& follType&&convType) {
              const key = `${follType}_${convType}_${app_id}_${convTarget}`;
              if (!map.has(key)) {
                map.set(key, {
                  tracking_type: follType,
                  conversion_type: convType,
                  deep_conversion_type: convTarget,
                  app_id,
                })
              }
            }
            return {
              tracking_type: follType,
              union_conver_type: convType,
              conver_id: this.addType ===1 ? '': name,
              ocpx_bid: price_2,
              is_deep: deepConv,
               deep_conver_id: this.addType ===1 ? '': deepName,
              deep_ocpx_bid: deep_price,
              deep_union_conver_type: convTarget,
            }
        });
        pre[id] = list;
        return pre;
      },{});
      const conversion_arr = [];
      for (const [key, value] of  map.entries()) {
        conversion_arr.push(value)
      }
      return { conversion_bid_list, conversion_arr };
    },
    reverseData(data) {
     
      const conversion_bid_list = Object.keys(data).reduce((pre, id)=>{
        const list = data[id].map(v=> {
          const { tracking_type,  union_conver_type, conver_id, ocpx_bid, deep_conver_id, deep_ocpx_bid, deep_union_conver_type, is_deep } = v;
           return {
              follType: tracking_type,
              convType: union_conver_type,
              name: conver_id,
              price_2: ocpx_bid,
              deepName: deep_conver_id,
              deep_price: deep_ocpx_bid,
              convTarget: deep_union_conver_type,
              deepConv: is_deep==='1'? '1': '0'
            }
        });
        pre[id] = list;
        return pre;
      },{});
      return conversion_bid_list
    },
    setFormData({ conversion_bid_list, idea_group_list, title }) {
      this.titleList = JSON.parse(title)
      // this.ad_group_list = JSON.parse(idea_group_list)
      const unwatch = this.$watch(
        'appList',
        (n)=> {
          if (n.length) {
            const data = this.reverseData(JSON.parse(conversion_bid_list))
            this.conversionFormData = data
            this.setPosData(data)
            this.ad_group_list = JSON.parse(idea_group_list)
            this.handleCoveData();
            this.posList = cloneDeep(this.conversionList[0].children);
            this.handleSourceData()
            if (unwatch) {
              unwatch()
            }
          }
        },
        { immediate: true }
      )
    },
    // 获取按版位的版位数据
    setPosData(data, addType = this.addType) {
      
      if ((!Object.keys(data).length)||addType !== 1) {
        this.posData = {}
        return;
      }
      const [app_id] = Object.keys(data)[0].split('_');
      this.displayType.map(v=> {
        const key = `${app_id}_${v.param_id}`;
        this.posData[v.param_id] = cloneDeep(data[key] || [])
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content-title {
  padding: 8px;
  p {
    color: #666;
  }
}
.ele-page {
  .tip {
    padding: 20px;
    border: 1px solid #ccc;
    background: #cce6ff;
    display: flex;
    align-items: center;
    span {
      color: #666;
      
    }
    i {
        color: #000;
        font-size: 16px;
        padding: 0 10px;
      }
  }
  .list-box {
    border: 1px solid #ccc;
    width: 100%;
    max-width: 1082px;
    min-width: 600px;
    margin-top: 20px;
    overflow: hidden;
    &-item {
      border-right: 1px solid #ccc;
      width: 33.33%;
      max-width: 360px;
      height: 550px;
      float: left;
      &:last-child {
        border-right: none;
      }
      .title {
        border-bottom: 1px solid #ccc;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        padding: 0 15px;
        font-size: 14px;
        p {
          color: #409EFF;
          cursor: pointer;
        }
      }
      .content {
        height: 510px;
        overflow: auto;
        &-item {
          padding-left: 12px;
          .item-head {
            display: flex;
            align-items: center;
            padding: 6px 0 0;
            p {
              max-width: 80%;
            }
            
          }
          .item-child {
            padding-left: 20px;
            margin-top: 6px;
          }
        }
      }
    }
  }
}
.scroll-list{
  height: 500px;
  overflow-y: auto;
}
</style>